/* eslint-disable vue/no-use-v-if-with-v-for */
<template>
  <v-data-table
    :page.sync="meta.current_page"
    :server-items-length="meta.total"
    :loading="isFetching"
    :headers="headers"
    :items="usersList"
    :items-per-page.sync="meta.per_page"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-toolbar-title>Пользователи</v-toolbar-title>
      </v-toolbar>
    </template>
    <template v-slot:[`item.contacts_phone`]="{ item }">
        <div v-if="Array.isArray(item.contacts_phone)">
            <span v-for="contacts_phone in item.contacts_phone" 
                :key="contacts_phone">
                {{contacts_phone}}<br/>
            </span>
        </div>
    </template>
  </v-data-table>
</template>

<script>
import * as api from '@/api/admin/workspaces';
export default {
    name: 'WorkspaceUsers',
    props: {
      workspaceId: {
          type: Number,
          require: true
      }
    },
    data: () => ({
        headers: [
          { text: 'id', value: 'id' },
          { text: 'email', value: 'email' },
          { text: 'ФИО', value: 'name' },
          { text: 'Телефоны', value: 'contacts_phone' },
        ],
        isFetching: false,
        users: [],
        meta: {},
    }),
    watch: {
        'meta.current_page': function (newVal, oldVal){
            if(newVal !== oldVal){
                this.load(this.workspaceId);
            }
        },
        'meta.per_page': function (newVal, oldVal){
            if(newVal !== oldVal){
                this.load(this.workspaceId);
            }
        },
    },
    created () {
        this.load(this.workspaceId);
    },
    methods: {
        setFetchState(){
            this.isFetching = true;
            this.setUsers([]);
        },
        setMeta(data){
            data.per_page = parseInt(data.per_page);
            this.meta = {...this.meta, ...data};
        },
        async load(workspaceId){
            try{
                this.setFetchState();
                let response = await api.users(workspaceId, {page: this.meta.current_page, per_page: this.meta.per_page});
                this.setUsers(response.data.data);
                this.setMeta({...response.data, data: null});
            }catch(err){
                console.log(err);
            }finally{
                this.isFetching = false;
            }
        },
        setUsers(data){
            this.users.splice(0, this.users.length, ...data);
        }
    },
    computed:{
        usersList(){
            return this.users.map(user => {
                return {
                    ...user,
                    contacts_phone: user.contacts_phone.map(contacts_phone => contacts_phone.contact)
                }
            });
        }
    },
}
</script>